// src/views/words-lists/components/CreateListModal.tsx
import React, { FC } from 'react';
import { Input, Button, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import AppModal, { ModalButtons } from '../../../components/AppModal';
import styles from '../FolderTreeView.module.less';

interface CreateListModalProps {
  visible: boolean;
  parentFolderId: number | null;
  name: string;
  description: string;
  onNameChange: (name: string) => void;
  onDescriptionChange: (description: string) => void;
  onCancel: () => void;
  onSubmit: () => void;
}

export const CreateListModal: FC<CreateListModalProps> = ({
  visible,
  parentFolderId,
  name,
  description,
  onNameChange,
  onDescriptionChange,
  onCancel,
  onSubmit,
}) => {
  const { t } = useTranslation();

  return (
    <AppModal
      title={parentFolderId ? t('folders:createList.titleInFolder') : t('folders:createList.title')}
      visible={visible}
      onCancel={onCancel}
    >
      <Form layout="vertical" className={styles.listModalForm}>
        <Form.Item required className={styles.listModalFormItem}>
          <Input
            placeholder={t('folders:createList.name')}
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            onPressEnter={onSubmit}
            maxLength={255}
            autoFocus
            className={styles.listModalInput}
          />
        </Form.Item>
        <Form.Item className={styles.listModalFormItem}>
          <Input
            placeholder={t('folders:createList.description')}
            value={description}
            onChange={(e) => onDescriptionChange(e.target.value)}
            maxLength={255}
            className={styles.listModalInput}
          />
        </Form.Item>
      </Form>
      {parentFolderId && (
        <p className={styles.listModalInfo}>
          {t('folders:createList.inFolderInfo')}
        </p>
      )}
      <ModalButtons>
        <Button onClick={onCancel}>
          {t('common:buttons.cancel')}
        </Button>
        <Button
          type="primary"
          onClick={onSubmit}
        >
          {t('common:buttons.create')}
        </Button>
      </ModalButtons>
    </AppModal>
  );
};
